module.exports = __webpack_public_path__ + "static/img/case_detail_08_1.bb8ef2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_08_1.png
// module id = Oo2S
// module chunks = 34